export default __webpack_public_path__ + "static/media/settings-off.0ad6df44.svg";